import { Directive } from '@angular/core';
import { CdkStepLabel } from '@angular/cdk/stepper';

@Directive({
    selector: '[kalStepLabel]',
    standalone: false
})
export class KalStepLabelDirective extends CdkStepLabel {

}
